module.exports = __webpack_public_path__ + "img/play-cover.ea110c59.png";